export enum FilterType {
    SearchResult = 'searchResult',
    CategoryResult = 'categoryResult',
    MixedCampaignResult = 'Campaign'
}

export const errorMessages = Object.freeze({
    InvalidConfiguration: 'Invalid filter configuration! Cannot continue.'
});

export const customFilterParams = Object.freeze({
    storeId: 'stocks.storeId.keyword',
    stockQuantity: 'stocks.stockQuantity',
    searchQuery: 'q'
});
